import { useScheduleEditableColumns } from './useScheduleEditableColumns'

export default useScheduleEditableColumns
